export default {
      id: "reefer-supply-usage",
      viewBox: "0 0 35 24",
      url: __webpack_public_path__ + "img/icons.svg#reefer-supply",
      toString: function () {
        return this.url;
      }
    }